module.exports = __webpack_public_path__ + "img/pistol.water.c4a9a96f.png";